import * as React from "react"

const SvgComponent = ({color,className}) => (
  <svg
    width={14}
    height={11}
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.998.958h.388L1.17 10.291H0L3.998.958Zm2.723 1.767h.76l.067 1.512h-.893l.066-1.512Zm-.156 2.27h1.064l.059 2.224h-1.22l.097-2.225ZM5.058.957H6.76l-.049 1.261h.779L7.442.958H9.12l2.943 9.333H7.908l-.136-2.018H6.424l-.118 2.018H2.14L5.059.958h-.001Zm4.734 0h.468L14 10.291h-.966L9.791.958Z"
      fill={color}
    />
  </svg>
)

export default SvgComponent
